import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { DelegationRole } from '@/swagger/constants/slash-enums';
import { API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_CREATE_DELEGATE_EMPLOYER, KEY_POST_CREATE_DELEGATE_EMPLOYER } from '../constants';
import { MOCK_RESPONSE_POST_CREATE_DELEGATE_EMPLOYER } from '../mocks';

type RequestPostCreateDelegateEmployer = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_PATH_KEY
>['request']['body'];

export type CallParamsPostCreateDelegateEmployer = Omit<
  RequestPostCreateDelegateEmployer,
  'delegationRole'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostCreateDelegateEmployer = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_PATH_KEY
>['response']['body'];

type CallErrorPostCreateDelegateEmployer = {
  message: string;
  code: number;
};

type CallSelectorsPostCreateDelegateEmployer = unknown;

const responseMapper = () => ({
  status: 'OK',
});

export const postCreateDelegateEmployerCall = createGeneralCall<
  CallParamsPostCreateDelegateEmployer,
  CallResponsePostCreateDelegateEmployer,
  CallErrorPostCreateDelegateEmployer,
  CallSelectorsPostCreateDelegateEmployer
>({
  id: KEY_POST_CREATE_DELEGATE_EMPLOYER,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_CREATE_DELEGATE_EMPLOYER(org as unknown as string);
  },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
        delegationRole: DelegationRole.HR_DELEGATE,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_CREATE_DELEGATE_EMPLOYER : undefined,
  responseMapper,
  responseExtractor: null,
});
